/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IEscrowUpdateDepositorNotificationsMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  escrowParams: Types.IEscrowUpdateDepositorNotificationsParams;
}>;

export type IEscrowUpdateDepositorNotificationsMutation = {
  __typename?: 'Mutation';
  escrowUpdateDepositorNotifications?: {
    __typename?: 'EscrowUpdateDepositorNotificationsPayload';
    success: boolean;
    errors?: Array<string> | null;
    escrow:
      | {
          __typename?: 'ContinuityEscrow';
          id: string;
          depositorActivityNotification: Types.ActivityNotificationEnum;
          depositorDisruptionNotification: Types.DisruptionNotificationEnum;
          depositorDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
        }
      | {
          __typename?: 'SaasEscrow';
          id: string;
          depositorActivityNotification: Types.ActivityNotificationEnum;
          depositorDisruptionNotification: Types.DisruptionNotificationEnum;
          depositorDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          depositorActivityNotification: Types.ActivityNotificationEnum;
          depositorDisruptionNotification: Types.DisruptionNotificationEnum;
          depositorDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
        };
  } | null;
};

export const EscrowUpdateDepositorNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'escrowUpdateDepositorNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowUpdateDepositorNotificationsParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowUpdateDepositorNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorActivityNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorDisruptionNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorDisruptionNotificationGracePeriod' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IEscrowUpdateDepositorNotificationsMutation,
  IEscrowUpdateDepositorNotificationsMutationVariables
>;
